module.exports = __webpack_public_path__ + "2397a3a1ec84723986b53ff482cc0b68.bg-main-mobile.jpg";


//////////////////
// WEBPACK FOOTER
// ./components/background/assets/bg-main-mobile.jpg
// module id = /DkW
// module chunks = 0